import store from '../store/store';

export function getInsetStyle() {
    let style = {
        backgroundColor: '#00663a'
    };
    if (store.state.insetTop) style.paddingTop = `${store.state.insetTop}px`;
    if (store.state.insetBottom) style.paddingBottom = `${store.state.insetBottom}px`;
    if (store.state.insetRight) style.paddingRight = `${store.state.insetRight}px`;
    if (store.state.insetLeft) style.paddingLeft = `${store.state.insetLeft}px`;
    return style;
}
